// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UNTrwj {
  display: inline-flex;
  align-items: center;
}

.u0Jsk5 {
  padding: var(--spacing-3, 24px) 0;
  margin: 0 auto;
}

.OmJSSM {
  margin-bottom: var(--spacing-3, 24px);
}

.S3f6uq {
  font-size: var(--type-title-lg-font-size, 20px);
  font-weight: var(--type-title-lg-font-weight, 600);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
}

.kngoqJ {
  margin-bottom: var(--spacing-3, 24px);
  padding: 0px !important;
  background-color: var(--surface-neutral-white, #ffffff);
}

.Jp3hAR {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-2, 16px) var(--spacing-3, 24px);
  border-bottom: 1px solid var(--stroke-neutral-subtle, #f2f2f2);
}

.SVDS6t {
  font-size: var(--type-title-md-font-size, 16px);
  font-weight: var(--type-title-md-font-weight, 600);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
}

.Fyc9H_ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-1, 8px);
  height: 32px;
  padding: var(--spacing-0-5, 4px) var(--spacing-1, 8px);
  font-size: var(--type-label-sm-font-size, 12px);
  border: none;
  color: var(--text-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
  background-color: var(--surface-primary-medium, #d64000);
  font-weight: var(--type-label-sm-font-weight, 600);
  cursor: pointer;
  transition: var(--transition-color, background-color 0.2s ease);
}

.Fyc9H_:hover {
  background-color: var(--surface-primary-strong, #b23600);
}

.ORjGy9 {
  width: 16px;
  height: 16px;
  margin-left: var(--spacing-0-5, 4px);
  filter: brightness(0) invert(1);
}

.IfqLAi {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.ND8asE {
  min-height: 150px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--spacing-3, 24px);
}

.A7xQwx {
  display: flex;
  gap: var(--spacing-3, 24px);
}

.vcGl_R {
  flex: 1;
  min-width: 0;
}

.qJopvF {
  width: 100%;
  box-sizing: border-box;
  background-color: var(--surface-neutral-white, #ffffff);
  flex: 1;
  padding: var(--spacing-1-5, 12px) 0 !important;
}

.dQF8cb {
  border-bottom: 1px solid var(--stroke-neutral-subtle, #f2f2f2);
  padding: 0 var(--spacing-1-5, 12px);
}

.yqQrkg {
  display: flex;
  gap: var(--spacing-1-5, 12px);
  padding: 0 var(--spacing-1-5, 12px);
}

.TzzSSM {
  padding: var(--spacing-1, 8px);
  border: none;
  background-color: transparent;
  font-size: var(--type-subtitle-md-font-size, 14px);
  font-weight: var(--type-subtitle-md-font-weight, 600);
  cursor: pointer;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
}

.BxFBgg {
  color: var(--text-primary-medium, #d64000);
  border-bottom: 2px solid var(--stroke-primary-medium, #d64000);
}

.iH5FFm {
  color: var(--text-neutral-stronger, #666666);
  border-bottom: 2px solid transparent;
}

.VMmlIw {
  padding: 0;
  min-height: 400px;
  overflow: hidden;
}

.cNoyRt {
  width: 72px;
  height: 72px;
  background-color: var(--surface-primary-subtle, rgba(202, 70, 21, 0.1));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tsGAN7 {
  width: 16px;
  height: 16px;
  color: var(--icon-primary-medium, #d64000);
}

.bNvIIP {
  text-align: center;
  max-width: 270px;
}

.S9CHQ3 {
  font-size: var(--type-subtitle-md-font-size, 14px);
  font-weight: var(--type-subtitle-md-font-weight, 600);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0 0 var(--spacing-1, 8px) 0;
  line-height: var(--type-subtitle-md-line-height, 1.8);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
}

.H13e3o {
  font-size: var(--type-paragraph-md-font-size, 14px);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  line-height: var(--type-paragraph-md-line-height, 1.8);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
}

.d6MqHo {
  display: flex;
  width: 355px;
  position: relative;
  flex-direction: column;
  gap: var(--spacing-3);
}

.f_N7La {
  position: absolute;
  right: 24px;
  top: 88px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HomePage.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;EAClD,wCAAwC;EACxC,SAAS;EACT,iEAAiE;AACnE;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sDAAsD;EACtD,8DAA8D;AAChE;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;EAClD,wCAAwC;EACxC,SAAS;EACT,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,YAAY;EACZ,sDAAsD;EACtD,+CAA+C;EAC/C,YAAY;EACZ,yCAAyC;EACzC,mCAAmC;EACnC,wDAAwD;EACxD,kDAAkD;EAClD,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uDAAuD;EACvD,OAAO;EACP,8CAA8C;AAChD;;AAEA;EACE,8DAA8D;EAC9D,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,6BAA6B;EAC7B,kDAAkD;EAClD,qDAAqD;EACrD,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,0CAA0C;EAC1C,8DAA8D;AAChE;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uEAAuE;EACvE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,qDAAqD;EACrD,wCAAwC;EACxC,mCAAmC;EACnC,qDAAqD;EACrD,iEAAiE;AACnE;;AAEA;EACE,mDAAmD;EACnD,wCAAwC;EACxC,SAAS;EACT,sDAAsD;EACtD,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".newRechargeOnboardingTarget {\n  display: inline-flex;\n  align-items: center;\n}\n\n.container {\n  padding: var(--spacing-3, 24px) 0;\n  margin: 0 auto;\n}\n\n.headerSection {\n  margin-bottom: var(--spacing-3, 24px);\n}\n\n.pageTitle {\n  font-size: var(--type-title-lg-font-size, 20px);\n  font-weight: var(--type-title-lg-font-weight, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n}\n\n.productsCard {\n  margin-bottom: var(--spacing-3, 24px);\n  padding: 0px !important;\n  background-color: var(--surface-neutral-white, #ffffff);\n}\n\n.cardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-2, 16px) var(--spacing-3, 24px);\n  border-bottom: 1px solid var(--stroke-neutral-subtle, #f2f2f2);\n}\n\n.cardTitle {\n  font-size: var(--type-title-md-font-size, 16px);\n  font-weight: var(--type-title-md-font-weight, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n}\n\n.newRechargeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-1, 8px);\n  height: 32px;\n  padding: var(--spacing-0-5, 4px) var(--spacing-1, 8px);\n  font-size: var(--type-label-sm-font-size, 12px);\n  border: none;\n  color: var(--text-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  background-color: var(--surface-primary-medium, #d64000);\n  font-weight: var(--type-label-sm-font-weight, 600);\n  cursor: pointer;\n  transition: var(--transition-color, background-color 0.2s ease);\n}\n\n.newRechargeButton:hover {\n  background-color: var(--surface-primary-strong, #b23600);\n}\n\n.iconChevron {\n  width: 16px;\n  height: 16px;\n  margin-left: var(--spacing-0-5, 4px);\n  filter: brightness(0) invert(1);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n  filter: brightness(0) invert(1);\n}\n\n.benefitCardsGrid {\n  min-height: 150px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--spacing-3, 24px);\n}\n\n.bottomSection {\n  display: flex;\n  gap: var(--spacing-3, 24px);\n}\n\n.rechargesMainColumn {\n  flex: 1;\n  min-width: 0;\n}\n\n.tabsCard {\n  width: 100%;\n  box-sizing: border-box;\n  background-color: var(--surface-neutral-white, #ffffff);\n  flex: 1;\n  padding: var(--spacing-1-5, 12px) 0 !important;\n}\n\n.tabHeader {\n  border-bottom: 1px solid var(--stroke-neutral-subtle, #f2f2f2);\n  padding: 0 var(--spacing-1-5, 12px);\n}\n\n.tabNavigation {\n  display: flex;\n  gap: var(--spacing-1-5, 12px);\n  padding: 0 var(--spacing-1-5, 12px);\n}\n\n.tabButton {\n  padding: var(--spacing-1, 8px);\n  border: none;\n  background-color: transparent;\n  font-size: var(--type-subtitle-md-font-size, 14px);\n  font-weight: var(--type-subtitle-md-font-weight, 600);\n  cursor: pointer;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n}\n\n.tabButtonActive {\n  color: var(--text-primary-medium, #d64000);\n  border-bottom: 2px solid var(--stroke-primary-medium, #d64000);\n}\n\n.tabButtonInactive {\n  color: var(--text-neutral-stronger, #666666);\n  border-bottom: 2px solid transparent;\n}\n\n.tabContent {\n  padding: 0;\n  min-height: 400px;\n  overflow: hidden;\n}\n\n.emptyStateIcon {\n  width: 72px;\n  height: 72px;\n  background-color: var(--surface-primary-subtle, rgba(202, 70, 21, 0.1));\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.emptyStateIconInner {\n  width: 16px;\n  height: 16px;\n  color: var(--icon-primary-medium, #d64000);\n}\n\n.emptyStateText {\n  text-align: center;\n  max-width: 270px;\n}\n\n.emptyStateTitle {\n  font-size: var(--type-subtitle-md-font-size, 14px);\n  font-weight: var(--type-subtitle-md-font-weight, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0 0 var(--spacing-1, 8px) 0;\n  line-height: var(--type-subtitle-md-line-height, 1.8);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n}\n\n.emptyStateDescription {\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  line-height: var(--type-paragraph-md-line-height, 1.8);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n}\n\n.tabsNavigation {\n  display: flex;\n  width: 355px;\n  position: relative;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.repeatRechargeErrorAlert {\n  position: absolute;\n  right: 24px;\n  top: 88px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newRechargeOnboardingTarget": `UNTrwj`,
	"container": `u0Jsk5`,
	"headerSection": `OmJSSM`,
	"pageTitle": `S3f6uq`,
	"productsCard": `kngoqJ`,
	"cardHeader": `Jp3hAR`,
	"cardTitle": `SVDS6t`,
	"newRechargeButton": `Fyc9H_`,
	"iconChevron": `ORjGy9`,
	"icon": `IfqLAi`,
	"benefitCardsGrid": `ND8asE`,
	"bottomSection": `A7xQwx`,
	"rechargesMainColumn": `vcGl_R`,
	"tabsCard": `qJopvF`,
	"tabHeader": `dQF8cb`,
	"tabNavigation": `yqQrkg`,
	"tabButton": `TzzSSM`,
	"tabButtonActive": `BxFBgg`,
	"tabButtonInactive": `iH5FFm`,
	"tabContent": `VMmlIw`,
	"emptyStateIcon": `cNoyRt`,
	"emptyStateIconInner": `tsGAN7`,
	"emptyStateText": `bNvIIP`,
	"emptyStateTitle": `S9CHQ3`,
	"emptyStateDescription": `H13e3o`,
	"tabsNavigation": `d6MqHo`,
	"repeatRechargeErrorAlert": `f_N7La`
};
module.exports = ___CSS_LOADER_EXPORT___;
